export default function(fields = {}, logoUrl = null) {
  return {
    ...fields,
    deleted: undefined,
    parent: undefined,
    acceptingOnlinePayment: undefined,
    alreadyRunningAward: undefined,
    address: {
      ...fields.address,
      deleted: undefined
    },
    invoiceAddress: {
      ...fields.invoiceAddress,
      deleted: undefined
    },
    logoUrl: logoUrl || fields.logoUrl,
    file: undefined
  }
}
